<div class="auth">
  <header class="auth-header">
    <img src="assets/images/logo.png" alt="SipSignal Efax Logo" class="auth-header-logo" />
  </header>

  <main class="auth-main">
    <h1 class="h2">Password recovery</h1>

    <p *ngIf="isLinkInvalid" class="form-error">This password reset link is invalid or has expired.</p>

    <form *ngIf="!isLinkInvalid" [formGroup]="form" class="auth-form" (ngSubmit)="resetPassword()">
      <div class="form-input-wrapper">
        <input
          formControlName="newPassword"
          [type]="isPasswordVisible ? 'text' : 'password'"
          placeholder="New password"
          class="form-input_lg"
        />

        <button type="button" class="form-input-button">
          <img
            [src]="isPasswordVisible ? 'assets/icons/eye.svg' : 'assets/icons/eye-off.svg'"
            alt="Toggle password visibility"
            class="form-input-icon"
            (click)="togglePasswordVisibility()"
          />
        </button>
      </div>

      <p *ngIf="form.get('newPassword').touched && form.get('newPassword').errors?.['pattern']" class="form-error">
        {{ passwordErrorMessage }}
      </p>

      <div class="form-input-wrapper">
        <input
          formControlName="repeatPassword"
          [type]="isRepeatPasswordVisible ? 'text' : 'password'"
          placeholder="Repeat password"
          class="form-input_lg"
        />

        <button type="button" class="form-input-button">
          <img
            [src]="isRepeatPasswordVisible ? 'assets/icons/eye.svg' : 'assets/icons/eye-off.svg'"
            alt="Toggle repeat password visibility"
            class="form-input-icon"
            (click)="toggleRepeatPasswordVisibility()"
          />
        </button>
      </div>

      <p *ngIf="form.get('repeatPassword').touched && form.errors?.['passwordsMismatch']" class="form-error">
        Passwords do not match
      </p>

      <button type="submit" [disabled]="form.invalid" class="btn_primary btn_lg auth-form-submit-button">
        Save password
      </button>

      <p *ngIf="isResetError" class="form-error">{{ resetErrorMessage }}</p>
    </form>
  </main>
</div>

<app-success-modal
  text="Password has been changed!"
  buttonText="Login"
  (close)="navigateToAuth()"
></app-success-modal>
